import type { AnalyticsObject, AnalyticsProperties } from '../types'

export class HeaderSearchIcon implements AnalyticsObject {
  name: string
  properties: AnalyticsProperties
  constructor() {
    this.name = `HeaderSearchIcon`
    this.properties = {}
  }
}
